// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* loading animation */
.spinner,
.spinner:before,
.spinner:after {
  width: 4px;
  height: 20px;
  background-color: #237bc2;
  border-radius: 0px;
}

.spinner {
  display: inline-block;
  position: relative;
}

.spinner:before,
.spinner:after {
  content: "";
  position: absolute;
  display: block;
  top: 0px;
}

.spinner:before {
  left: -6px;
}

.spinner:after {
  left: 6px;
}
@keyframes bounce-middle {
  0% {
    height: 4px;
    margin-top: 8px;
    margin-bottom: 8px;
    background-color: transparent;
  }
  50% {
    height: 20px;
    margin-top: 0px;
    margin-bottom: 0px;
    background-color: #237bc2;
  }
  100% {
    height: 4px;
    margin-top: 8px;
    margin-bottom: 8px;
    background-color: transparent;
  }
}
.spinner-bounce-middle {
  animation: bounce-middle 0.6s ease 0.1s infinite;
  position: absolute;
  top: 50%;
  left: 50%;
}

.spinner-bounce-middle:before,
.spinner-bounce-middle:after {
  top: 50%;
  transform: translateY(-10px) translateZ(0);
}

.spinner-bounce-middle:before {
  animation: bounce-middle 0.6s ease 0s infinite;
}

.spinner-bounce-middle:after {
  animation: bounce-middle 0.6s ease 0.2s infinite;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/imported-forecasts/imported-forecasts-loading-overlay/imported-forecasts-loading-overlay.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/pages/imported-forecasts/imported-forecasts-loading-overlay/imported-forecasts-loading-overlay.component.scss"],"names":[],"mappings":"AAAA,sBAAA;AACA;;;EAGE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;ACCF;;ADEA;EACE,qBAAA;EACA,kBAAA;ACCF;;ADEA;;EAEE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;ACCF;;ADEA;EACE,UAAA;ACCF;;ADEA;EACE,SAAA;ACCF;ADuBA;EACE;IACE,WAAA;IACA,eAAA;IACA,kBAAA;IACA,6BAAA;ECAF;EDEA;IACE,YAAA;IACA,eAAA;IACA,kBAAA;IACA,yBAAA;ECAF;EDEA;IACE,WAAA;IACA,eAAA;IACA,kBAAA;IACA,6BAAA;ECAF;AACF;ADGA;EAEE,gDAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ACDF;;ADIA;;EAEE,QAAA;EAEA,0CAAA;ACDF;;ADIA;EAEE,8CAAA;ACDF;;ADIA;EAEE,gDAAA;ACDF","sourcesContent":["/* loading animation */\n.spinner,\n.spinner:before,\n.spinner:after {\n  width: 4px;\n  height: 20px;\n  background-color: #237bc2;\n  border-radius: 0px;\n}\n\n.spinner {\n  display: inline-block;\n  position: relative;\n}\n\n.spinner:before,\n.spinner:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  top: 0px;\n}\n\n.spinner:before {\n  left: -6px;\n}\n\n.spinner:after {\n  left: 6px;\n}\n\n@-webkit-keyframes bounce-middle {\n  0% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n  50% {\n    height: 20px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    background-color: #237bc2;\n  }\n  100% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n}\n\n@keyframes bounce-middle {\n  0% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n  50% {\n    height: 20px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    background-color: #237bc2;\n  }\n  100% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n}\n\n.spinner-bounce-middle {\n  -webkit-animation: bounce-middle 0.6s ease 0.1s infinite;\n  animation: bounce-middle 0.6s ease 0.1s infinite;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.spinner-bounce-middle:before,\n.spinner-bounce-middle:after {\n  top: 50%;\n  -webkit-transform: translateY(-10px) translateZ(0);\n  transform: translateY(-10px) translateZ(0);\n}\n\n.spinner-bounce-middle:before {\n  -webkit-animation: bounce-middle 0.6s ease 0s infinite;\n  animation: bounce-middle 0.6s ease 0s infinite;\n}\n\n.spinner-bounce-middle:after {\n  -webkit-animation: bounce-middle 0.6s ease 0.2s infinite;\n  animation: bounce-middle 0.6s ease 0.2s infinite;\n}\n\n","/* loading animation */\n.spinner,\n.spinner:before,\n.spinner:after {\n  width: 4px;\n  height: 20px;\n  background-color: #237bc2;\n  border-radius: 0px;\n}\n\n.spinner {\n  display: inline-block;\n  position: relative;\n}\n\n.spinner:before,\n.spinner:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  top: 0px;\n}\n\n.spinner:before {\n  left: -6px;\n}\n\n.spinner:after {\n  left: 6px;\n}\n\n@-webkit-keyframes bounce-middle {\n  0% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n  50% {\n    height: 20px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    background-color: #237bc2;\n  }\n  100% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n}\n@keyframes bounce-middle {\n  0% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n  50% {\n    height: 20px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    background-color: #237bc2;\n  }\n  100% {\n    height: 4px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n  }\n}\n.spinner-bounce-middle {\n  -webkit-animation: bounce-middle 0.6s ease 0.1s infinite;\n  animation: bounce-middle 0.6s ease 0.1s infinite;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.spinner-bounce-middle:before,\n.spinner-bounce-middle:after {\n  top: 50%;\n  -webkit-transform: translateY(-10px) translateZ(0);\n  transform: translateY(-10px) translateZ(0);\n}\n\n.spinner-bounce-middle:before {\n  -webkit-animation: bounce-middle 0.6s ease 0s infinite;\n  animation: bounce-middle 0.6s ease 0s infinite;\n}\n\n.spinner-bounce-middle:after {\n  -webkit-animation: bounce-middle 0.6s ease 0.2s infinite;\n  animation: bounce-middle 0.6s ease 0.2s infinite;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
